import _regeneratorRuntime from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
export var createTestAudioWorkletProcessorPostMessageSupport = function createTestAudioWorkletProcessorPostMessageSupport(nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var blob, offlineAudioContext, url, isEmittingMessageEvents, isEmittingProcessorErrorEvents, audioWorkletNode, oscillator;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(nativeAudioWorkletNodeConstructor === null)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", true);

          case 2:
            if (!(nativeOfflineAudioContextConstructor === null)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            blob = new Blob(['class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'], {
              type: 'application/javascript; charset=utf-8'
            });
            offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 8000);
            url = URL.createObjectURL(blob);
            isEmittingMessageEvents = false;
            isEmittingProcessorErrorEvents = false;
            _context.prev = 9;
            _context.next = 12;
            return offlineAudioContext.audioWorklet.addModule(url);

          case 12:
            audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
              numberOfOutputs: 0
            });
            oscillator = offlineAudioContext.createOscillator();

            audioWorkletNode.port.onmessage = function () {
              return isEmittingMessageEvents = true;
            };

            audioWorkletNode.onprocessorerror = function () {
              return isEmittingProcessorErrorEvents = true;
            };

            oscillator.connect(audioWorkletNode);
            _context.next = 19;
            return offlineAudioContext.startRendering();

          case 19:
            _context.next = 23;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](9);

          case 23:
            _context.prev = 23;
            URL.revokeObjectURL(url);
            return _context.finish(23);

          case 26:
            return _context.abrupt("return", isEmittingMessageEvents && !isEmittingProcessorErrorEvents);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 21, 23, 26]]);
  }));
};